import type { StrapiMedia, StrapiMediaResponsiveFormats, StrapiBackgroundImage, StrapiBackgroundImageMobile } from '@nimbus/types'
import { useStrapiConfig } from '#imports'

export const useStrapiMedia = () => {
    const { baseUrl } = useStrapiConfig()

    const getStrapiMediaUrl = (relativeUrl?: string) => {
        if (!relativeUrl) return undefined

        // Prepend Strapi baseUrl in devmode, since media is located here on the strapi dev-server
        if (process.env.NODE_ENV !== 'production') {
            return `${baseUrl}${relativeUrl}`
        }

        return relativeUrl
    }

    const getStrapiMediaAttr = (mediaObj: StrapiMedia | StrapiBackgroundImage | StrapiBackgroundImageMobile, responsiveSize?: StrapiMediaResponsiveFormats) => {
        if (!mediaObj) {
            return null
        }

        // If media has responsive sizes, return the requested sizes attributes
        // Todo: Fix types for mediaAttributes.formats in Strapi-server
        const formats = mediaObj.formats as Record<string, unknown> | undefined
        if (responsiveSize && formats?.[responsiveSize]) {
            return formats[responsiveSize] as typeof mediaObj
        }

        return mediaObj
    }

    return {
        getStrapiMediaAttr,
        getStrapiMediaUrl,
    }
}
